export const Authenticate  = `
    mutation Authenticate ($input: AuthenticateInput!)  {
        authenticate (input: $input) {
            clientMutationId,
            jwtToken
        }
    }
`;
